import script from "./MRankingSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MRankingSection.vue?vue&type=script&setup=true&lang=ts"

import "./MRankingSection.vue?vue&type=style&index=0&id=175aae39&lang=less"

const __exports__ = script;

export default __exports__